import Vue from 'vue'
import vuelidateErrorExtractor from 'vuelidate-error-extractor'

Vue.use(vuelidateErrorExtractor, {
    i18n: 'validation',
})
